export default {
  path: 'vehicles',
  name: 'FleetVehicles',
  component: () => import(/* webpackChunkName: "fleet" */ '../views/FleetVehiclesView.vue')
}
